import { Autosuggest, Button, Header, Link, Pagination, Select, SpaceBetween, Table } from '@cloudscape-design/components'
import { useQueryData, useTextSearch } from '../hooks/useQueryData'
import { useState } from 'react'
import SelectInput from '../widgets/SelectInput'
import LabeledInput from '../widgets/LabeledInput'

export default ({ searchText }: { searchText: string }) => {
  const [ filter, setFilter ] = useState('All')
  const [ currentPage, setCurrentPage ] = useState(1)
  const [ pageSize ] = useState(15)
  const [ search, setSearch] = useState(searchText)

  // const {data, count} = useTextSearch(search?.trim(), filter, currentPage, pageSize)
  const {data, isLoading, refetch} = useQueryData('Search')
  const filteredData = data?.data?.filter((e: any) => {
    if (filter === 'All' && !(e.Class === 'Intake' && e.Status === "Case Created")) return true
    if (filter === 'Case') return e.Class === 'Case'
    if (filter === 'Contact') return e.Class === 'Contact'
    if (filter === 'Intake') return e.Class === 'Intake'
    return false
  })
  const searchData = filteredData?.filter((e: any) => {
    if (e.Terms.includes(search?.toLowerCase())) return true
  })  // search by name
  const count = searchData?.length ?? 0
  const paginatedData = searchData?.slice((currentPage - 1) * pageSize, currentPage * pageSize)

  return (
    <Table
      columnDefinitions={[
        { id: "Type",   header: "Type",   cell: e => e.Class },
        { id: "Name",   header: "Name", cell: e => NameLinkForHit(e) },
        // { id: "Client", header: "Client", cell:  e => e.Client },
        { id: "AssignedTo", header: "Assigned To", cell: e => e.AssignedTo },
        { id: "Status", header: "Status", cell: e => e.Status },
      ]}
      items={ paginatedData ?? [] }
      loadingText="Loading Search Results"
      loading = {isLoading}
      trackBy={e => e.objectId}
      empty="No Search Results"
      header={ <Header actions={
        <SpaceBetween size="m" direction="horizontal">
          <SelectInput value={filter} onChange={(v) => setFilter(v.detail.value)} 
            options={["All", "Case", "Contact"]} />
          <LabeledInput label="" readOnly={false} value={search} onChange={(v) => setSearch(v.detail.value)} />
          {/* <Autosuggest
            placeholder="Search" value={search}
            onChange={event => setSearch(event.detail.value)}
            // onKeyDown={event => {event.detail.key === "Enter" && runSearch()}}
            // onSelect={event => runSearch(event.detail.value)} 
          /> */}
          <Pagination 
            currentPageIndex={currentPage} 
            pagesCount={Math.ceil(count / pageSize)}
            onChange={({ detail }) => setCurrentPage(detail.currentPageIndex) } />
          <Button iconName="refresh" variant="icon" ariaLabel="Reload" onClick={() => refetch()} />

        </SpaceBetween>
        }>{isLoading ? 'Loading' : (count + ' result(s) for: ' + search)}</Header> } 
    />
  )
}

function NameLinkForHit(hit: any) {
  switch (hit.Class) {
    case "Intake":
      return <Link href={"/intakeform/" + hit.Id + "/"}>{hit.Name}</Link>
    case "Case":
      return <Link href={"/case/" + hit.Id + "/"}>{hit.Name}</Link>
    case "Contact":
      return <Link href={"/contactform/" + hit.Id + "/"}>{hit.Name}</Link>
  }
  
  return hit.name
}